/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.14.0
 * @since 1.14.0
 */

import { IFormAddressReducer } from '../formAddressReducer';
import { EFormAddressField } from '../types/formAddressTypes';

export const formAddressInitialState: IFormAddressReducer = {
    addressConfiguration: {
        airId: '',
        addressId: '',
        addressString: '',
        [EFormAddressField.apartment]: null,
        [EFormAddressField.block]: null,
        [EFormAddressField.city]: null,
        [EFormAddressField.house]: null,
        [EFormAddressField.planningElement]: null,
        // ЭПС по умолчанию не выбран
        [EFormAddressField.planningElementOptional]: true,
        [EFormAddressField.street]: null,
        [EFormAddressField.structure]: null,
    },
    isFormInit: false,
    searchFoundItems: {},
    searchIsLoading: {},
};

/*
* -------------------------------------------
*       Form Initialize
* -------------------------------------------
*/

export const FORM_ADDRESS_INITIALIZE = '@@b2b_portal_ui/form/address/FORM_ADDRESS_INITIALIZE';

/*
* -------------------------------------------
*       Search for Address Matches
* -------------------------------------------
*/

export const FORM_ADDRESS_SEARCH_START = '@@b2b_portal_ui/form/address/FORM_ADDRESS_SEARCH_START';
export const FORM_ADDRESS_SEARCH_SUCCESS = '@@b2b_portal_ui/form/address/FORM_ADDRESS_SEARCH_SUCCESS';
export const FORM_ADDRESS_SEARCH_FAILURE = '@@b2b_portal_ui/form/address/FORM_ADDRESS_SEARCH_FAILURE';

/*
* -------------------------------------------
*       Get Address as String
* -------------------------------------------
*/

export const FORM_ADDRESS_GET_AS_STRING_START = '@@b2b_portal_ui/form/address/FORM_ADDRESS_GET_AS_STRING_START';
export const FORM_ADDRESS_GET_AS_STRING_SUCCESS = '@@b2b_portal_ui/form/address/FORM_ADDRESS_GET_AS_STRING_SUCCESS';
export const FORM_ADDRESS_GET_AS_STRING_FAILURE = '@@b2b_portal_ui/form/address/FORM_ADDRESS_GET_AS_STRING_FAILURE';
